import { BuyerSignUpForm } from './BuyerSignUpForm';

export function BuyerSignUp() {
    return <BuyerSignUpForm data-testid="BuyerSignUp" />;
}
